export default "__VITE_ASSET__DxUhgRrB__"